module.exports = __webpack_public_path__ + "img/book-read.4378e596.svg";